/**
 * resusable component to create and edit sentiment questions
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import actions

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Modal from '../../../global/components/modals/Modal.js.jsx';

import {
  TextInput
  , UrlInput
} from '../../../global/components/forms';

import SentimentQuestion from './SentimentQuestion.js.jsx';

class SentimentQuestionPreviewModal extends Base {
  constructor(props) {
    super(props);
    this._bind(
      '_closeModal'
    )
  }

  _closeModal() {
    this.props.closeModal(); 
  }

  render() {
    const { isOpen, questionList } = this.props;

    return (
      <Modal
        cardSize='medium'
        closeAction={this._closeModal}
        closeText="Cancel changes"
        confirmAction={null}
        confirmText="Save"
        disableConfirm={null}
        isOpen={isOpen}
        // modalHeader={`User sentiment`}
        modalClasses='black'
        showButtons={false}
      >
        { questionList && questionList.length > 0 ? 
          <div className="yt-container">
            <div className="yt-row">
              {questionList.map((question, i) => 
                <SentimentQuestion
                  key={i}
                  question={question}
                />
              )}
            </div>
            <div className="yt-row center-horiz">
              <button onClick={this._closeModal} className="submit-sentiment-btn"><b>Submit Feedback</b></button>
            </div>
          </div>
          : null
        }
      </Modal>
    )
  }
}

SentimentQuestionPreviewModal.propTypes = {
  closeModal: PropTypes.func.isRequired
  , dispatch: PropTypes.func.isRequired
  , formType: PropTypes.string
  , isOpen: PropTypes.bool
}

SentimentQuestionPreviewModal.defaultProps = {
  isOpen: false
}


export default SentimentQuestionPreviewModal;



// WEBPACK FOOTER //
// modules/sentimentQuestion/components/SentimentQuestionPreviewModal.js.jsx